import { render, staticRenderFns } from "./TypographyTest.vue?vue&type=template&id=03a57430&scoped=true&lang=pug&"
import script from "./TypographyTest.vue?vue&type=script&lang=ts&"
export * from "./TypographyTest.vue?vue&type=script&lang=ts&"
import style0 from "./TypographyTest.vue?vue&type=style&index=0&id=03a57430&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03a57430",
  null
  
)

export default component.exports